import React from 'react'
import './401k_plan.scss'
import {
    MainHeading,
    Breadcrumb,
    NewsCard,
    CustomerExperience401,
    FigureCards,
    TwoSectionContent,
    Faq,
    HelpForm,
    OneBlueCard
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const Plan401k = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "401(k) plans and life insurance", link: "/what-we-offer/insurance-products/401k-plans-and-life-insurance" },
        { label: "401(k) and other retirement plans", link: "/what-we-offer/insurance-products/401k-plans-and-life-insurance/401k-plans" },

    ];
    const NewsCardData = [
        {
            id: 1,
            title: 'Getting your employees ready to retire',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'Read more >',
        },
        {
            id: 2,
            title: 'Secure Act 2.0',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'Read more >',
        },
        {
            id: 3,
            title: 'Sentry news',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'Read more >',
        },

    ];
    const bluecardData = {
        heading1: 'Planning for your business and future',
        para1: 'At Sentry, our 401(k) plan solutions help employers like you attract and retain talent. By providing your employees with quality retirement products and services, you can help them plan for—and achieve—their retirement goals.',
        para2: "But we know your retirement plan isn’t only for your employees. It needs to be right for you, too. That’s why we take the time to get to know your business, so we can help you design a retirement savings program that works for you and your employees. We’ll also:",
        para3: "For more than 50 years, we’ve helped businesses around the country build and maintain 401(k) and other retirement plans. And we’re ready to help you do it, too.",
        blue_card_heading: 'Want to learn more about how we can help you?',
        blue_card_para: 'Our account executives and retirement plan specialists can work with you to create a plan that works for you and your employees.',
        button_text: 'Contact us'
    }
    const featuredCard = [
        {
            id: 1,
            value: "5k+",
            unit: "Sentry associates",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 2,
            value: "8",
            unit: "Sentry leaders",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
        {
            id: 3,
            value: "1992",
            unit: "First year",
            description: "While we’ve been in business a long time, we’ve had just eight leaders during our more than 120-year history.",
        },
    ];
    const faqdata = [
        {
            id: 1,
            eventKey: 1,
            header: 'How much do I need to save for retirement?',
            body: 'We understand the future can be uncertain, and that it can be difficult to determine how much money you’ll need for retirement. You can take advantage of our dynamic online calculators to help you make informed decisions.'
        },
        {
            id: 2,
            eventKey: 2,
            header: 'What types of retirement plans and investment options do you offer?',
            body: 'We understand the future can be uncertain, and that it can be difficult to determine how much money you’ll need for retirement. You can take advantage of our dynamic online calculators to help you make informed decisions.'
        },
        {
            id: 3,
            eventKey: 3,
            header: 'Where can my employees and I get financial and investment advice?',
            body: 'We understand the future can be uncertain, and that it can be difficult to determine how much money you’ll need for retirement. You can take advantage of our dynamic online calculators to help you make informed decisions.'
        },
    ]
    return (
        <>
            <div className='plans_401_main'>
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Business 401(k) and other retirement plans" showshare={false} />
                    {/* Tabs */}
                    <OneBlueCard data={bluecardData} />
                    {/* video section */}
                    <CustomerExperience401 />
                    {/* Featured Card */}
                    <FigureCards data={featuredCard} heading="Significant figures" />
                    {/* We keep things simple */}
                    <TwoSectionContent />
                    {/* Faq */}
                    <Faq heading="FAQs" FaqData={faqdata} />
                    {/* news card section */}
                    <NewsCard Title="More reasons to choose Sentry" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    {/* Bussiness Form */}
                    <HelpForm />
                </Container>
            </div>
        </>
    )
}

export default Plan401k;